exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3VcTHidDgPFSFsbw3AP4I0{vertical-align:middle;width:14px;height:14px;display:inline-block}", ""]);
// Exports
exports.locals = {
	"linkSpinner": "_3VcTHidDgPFSFsbw3AP4I0"
};